<section id="book" class="reservation-area ptb-100 jarallax" data-jarallax='{"speed": 0.3}'>
  <div class="container">
    <h2>Book A Room Now!</h2>
    <a href="#" class="btn btn-primary" data-toggle="modal" data-target="#reservationModal"
      >Book Now</a
    >
  </div>
</section>
